import JourneyCards from '../../../../../components/JourneyCards';
import { SectionTitle, Subtext } from '../../../shared/styles';
import { HOW_WE_WORK_SECTION } from './constants';
import { CLIENT_JOURNEY } from '../../constants';
import { SectionInnerWrapper, ButtonWrapper } from './styles';
import CTAButton from '../../../../../ui/ctaButton';
import { openSimplePracticeConsultation } from '../../../../../utils/simplePractice';

const HowWeWorkSection = () => {
  const handleStartConsultation = () => {
    openSimplePracticeConsultation();
  };

  return (
    <SectionInnerWrapper>
      <SectionTitle align="center">{HOW_WE_WORK_SECTION.title}</SectionTitle>
      <Subtext align="center">{HOW_WE_WORK_SECTION.subtext}</Subtext>

      <JourneyCards steps={CLIENT_JOURNEY} />

      <ButtonWrapper>
        <CTAButton
          variant="contained"
          text={HOW_WE_WORK_SECTION.buttonText}
          onClick={handleStartConsultation}
        />
      </ButtonWrapper>
    </SectionInnerWrapper>
  );
};

export default HowWeWorkSection;
